module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "id": _vm.id
    }
  }, [_c('input', {
    ref: "Checkbox",
    attrs: {
      "name": _vm.name,
      "type": "checkbox",
      "data-parsley-required": "",
      "required": _vm.isRequired
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.handleDeclaration
    }
  }), _vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), (_vm.help_text) ? [_c('p', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.help_text))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f1526b2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/declarations.vue
// module id = 958
// module chunks = 0